export default "__VITE_ASSET__f872ef67__"